import { SF_ } from "./scaling";
const BLUNT = {
  physical: {
    type: "fated",
    fixed: SF_(1.5),
    qualityScaling: SF_(0.05),
    rating: 1
  }
};
const PIERCING = {
  physical: {
    type: "chance",
    min: SF_(1.2),
    max: SF_(1.8),
    qualityScaling: SF_(0.03),
    rating: 1
  }
};
const KEEN_PIERCING = {
  physical: {
    type: "chance",
    min: SF_(1.5),
    max: SF_(2.5),
    qualityScaling: SF_(0.04),
    rating: 1
  }
};
const SLASHING = {
  physical: {
    type: "chance",
    min: SF_(1),
    max: SF_(2),
    qualityScaling: SF_(0.04),
    rating: 1
  }
};
const SLASHING_2H = {
  physical: {
    type: "chance",
    min: SF_(1.5),
    max: SF_(2.5),
    qualityScaling: SF_(0.05),
    rating: 1
  }
};
const KEEN_SLASHING = {
  physical: {
    type: "chance",
    min: SF_(1.3),
    max: SF_(2.3),
    qualityScaling: SF_(0.04),
    rating: 1
  }
};
const FIRE = {
  red: {
    type: "chance",
    min: SF_(2.8),
    max: SF_(3.2),
    qualityScaling: SF_(0.3),
    rating: 2
  }
};
const ARCANE = {
  blue: {
    type: "chance",
    min: SF_(2),
    max: SF_(4.5),
    qualityScaling: SF_(0.25),
    rating: 2
  }
};
const RADIANT_DAMAGE = {
  gold: {
    type: "fated",
    fixed: SF_(1),
    qualityScaling: SF_(0.4),
    rating: 1
  }
};
const RADIANT_HEALING = {
  gold: {
    type: "chance",
    min: SF_(1.6),
    max: SF_(2.4),
    qualityScaling: SF_(0.5),
    rating: 3
  }
};
const SHADOW = {
  black: {
    type: "chance",
    min: SF_(2.4),
    max: SF_(3),
    qualityScaling: SF_(0.3),
    rating: 2
  }
};
const SHADOW_TOUCH = {
  black: {
    type: "chance",
    min: SF_(1.8),
    max: SF_(2.4),
    qualityScaling: SF_(0.25),
    rating: 2
  }
};
const NATURE_DAMAGE = {
  green: {
    type: "chance",
    min: SF_(2.5),
    max: SF_(2.9),
    rating: 2
  }
};
const NATURE_HEALING = {
  green: {
    type: "fated",
    fixed: SF_(1.8),
    qualityScaling: SF_(0.4),
    rating: 2
  }
};
const SCALING = {
  BLUNT,
  PIERCING,
  KEEN_PIERCING,
  SLASHING,
  SLASHING_2H,
  KEEN_SLASHING,
  FIRE,
  ARCANE,
  RADIANT_DAMAGE,
  RADIANT_HEALING,
  SHADOW,
  SHADOW_TOUCH,
  NATURE_DAMAGE,
  NATURE_HEALING
};
const SPICE_MAGIC = {
  type: "fated",
  fixed: SF_(1.5),
  qualityScaling: SF_(0.2),
  rating: 1
};
export {
  SCALING,
  SPICE_MAGIC
};
//# sourceMappingURL=data:application/json;base64,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
